// Acquisizione PUNTUALE della posizione (solo alla pressione di Timbra/Chiudi). Nessun tracciamento.
// Ritorna {lat, lng, accuracy} (la migliore ottenuta) oppure null se la posizione non è disponibile.
export const GEO_REQUIRED_TITLE = "Geolocalizzazione necessaria";
export const GEO_REQUIRED_MSG =
  "Per timbrare questo servizio devi attivare la geolocalizzazione del cellulare e consentire a Orbit di accedere alla posizione. Attiva la geolocalizzazione e riprova.";

const toPos = (p) => ({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy });

export function acquirePosition(maxAccuracy) {
  if (typeof navigator === "undefined" || !navigator.geolocation) return Promise.resolve(null);
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (p) => {
        const first = toPos(p);
        if (!maxAccuracy || first.accuracy <= maxAccuracy) return resolve(first);
        // Posizione imprecisa: breve tentativo (max 8 s) di ottenerne una più precisa, poi stop.
        let best = first;
        let id = null;
        const done = () => { if (id !== null) navigator.geolocation.clearWatch(id); clearTimeout(t); resolve(best); };
        const t = setTimeout(done, 8000);
        id = navigator.geolocation.watchPosition(
          (q) => { const c = toPos(q); if (c.accuracy < best.accuracy) best = c; if (best.accuracy <= maxAccuracy) done(); },
          () => done(),
          { enableHighAccuracy: true, maximumAge: 0, timeout: 8000 },
        );
      },
      () => resolve(null),
      { enableHighAccuracy: true, maximumAge: 0, timeout: 12000 },
    );
  });
}

// POST con verifica geografica server-driven: il server risponde 428 solo se il servizio la richiede.
export async function postWithGeo(api, url, body) {
  try {
    return await api.post(url, body);
  } catch (err) {
    const d = err.response?.status === 428 ? err.response.data?.detail : null;
    if (!d || !String(d.code || "").startsWith("geo_")) throw err;
    const pos = await acquirePosition(d.max_accuracy_m);
    if (!pos) { const e = new Error(GEO_REQUIRED_MSG); e.geo = true; throw e; }
    try {
      return await api.post(url, { ...body, geo: pos });
    } catch (err2) {
      const d2 = err2.response?.status === 428 ? err2.response.data?.detail : null;
      if (d2) { const e = new Error(d2.msg || GEO_REQUIRED_MSG); e.geo = true; throw e; }
      throw err2;
    }
  }
}

export function geoAnomalyText(phase, geo) {
  if (!geo) return null;
  const what = phase === "close" ? "Chiusura servizio effettuata" : "Timbratura effettuata";
  return { title: "Fuori area geolocalizzazione", detail: `${what} a ${geo.distance_m} m dalla sede`, tolerance: `Tolleranza prevista: ${geo.tolerance_m} m` };
}
